import React from "react";
import { styled, EmotionComponent } from "../../styled";
import { Box, BoxProps } from "../../";
import { InputDropdownRenderListItemProps } from "./";

const highlightedBgColor = "#e2eef9";
const highlightedColor = "#0074d9";

type ListItemContainerProps = BoxProps & {
  isHighlighted: boolean;
};

const ListItemContainer: EmotionComponent<ListItemContainerProps> = styled(
  Box
)<ListItemContainerProps>`
  ${(props) =>
    `
      background-color: ${props.isHighlighted ? highlightedBgColor : "white"};
      color: ${props.isHighlighted ? highlightedColor : "#333"};
    `}
  padding: 10px;
  &:hover {
    color: ${highlightedColor};
    background-color: ${highlightedBgColor};
  }
`;

export const defaultRenderItem = <T extends unknown>({
  itemData,
  isHighlighted,
}: InputDropdownRenderListItemProps<T>) => (
  <ListItemContainer isHighlighted={isHighlighted} fontWeight="light">
    {itemData.title}
  </ListItemContainer>
);

export function ensureHighlightedItemIsVisible({
  itemRef,
  itemContainerRef,
}: {
  itemRef: React.RefObject<HTMLLIElement>;
  itemContainerRef: React.RefObject<HTMLDivElement>;
}) {
  if (
    itemRef.current?.offsetParent != null &&
    itemContainerRef.current?.offsetTop != null
  ) {
    const itemOffsetRelativeToContainer =
      itemRef.current.offsetParent === itemContainerRef.current
        ? itemRef.current.offsetTop
        : itemRef.current.offsetTop - itemContainerRef.current.offsetTop;

    let { scrollTop } = itemContainerRef.current; // Top of the visible area

    if (itemOffsetRelativeToContainer < scrollTop) {
      // Item is off the top of the visible area
      scrollTop = itemOffsetRelativeToContainer;
    } else if (
      itemOffsetRelativeToContainer + itemRef.current.offsetHeight >
      scrollTop + itemContainerRef.current.offsetHeight
    ) {
      // Item is off the bottom of the visible area
      scrollTop =
        itemOffsetRelativeToContainer +
        itemRef.current.offsetHeight -
        itemContainerRef.current.offsetHeight;
    }

    if (scrollTop !== itemContainerRef.current.scrollTop) {
      itemContainerRef.current.scrollTop = scrollTop;
    }
  }
}
